import Guess from './Guess';

export default Guess;